import { Col, Form, Input, InputNumber, Row } from 'antd'
import { Gutter } from 'antd/es/grid/row'
import React, { FunctionComponent } from 'react'

import { BUYBACK_FIELD as FIELD } from '../../../common/buybackTypes'
import { inputNumberFormatter } from '../../utils/buybackHelpers'
import {
  MonitNode,
  PriceEstimateSelectBox,
} from '../PriceEstimateSelectBox/PriceEstimateSelectBox'

const gutter: Gutter | [Gutter, Gutter] = [16, 16]

export interface BuybackFormParametersFragmentProps {
  priceEstimates?: MonitNode[]
  loading?: boolean
}

export const BuybackFormParametersFragment: FunctionComponent<BuybackFormParametersFragmentProps> =
  props => {
    return (
      <Row gutter={gutter}>
        <Col xs={24} md={12}>
          <Form.Item label="Použít cenový odhad">
            <PriceEstimateSelectBox
              priceEstimates={props.priceEstimates}
              loading={props.loading}
            />
          </Form.Item>
        </Col>

        <Col xs={24} md={6}>
          <Form.Item hidden name={FIELD.EstimatedPrice}>
            <InputNumber />
          </Form.Item>

          <Form.Item name={FIELD.PropertyPrice} label="Tržní cena nemovitosti">
            <InputNumber
              min={0}
              step={100_000}
              className="w-full"
              formatter={inputNumberFormatter}
              addonAfter="Kč"
            />
          </Form.Item>
        </Col>

        <Col xs={24} md={6}>
          <Form.Item name={FIELD.PriceEstimateDate} label="Odhad k datu">
            <Input />
          </Form.Item>
        </Col>
      </Row>
    )
  }
